/**
 * Resource Types Constants
 * Centralized definitions for all resource types in the application
 */

export const RESOURCE_TYPES = {
    FLASHCARD_DECK: "flashcard_deck",
    QUIZ: "quiz",
    ARTICLE: "article",
    BOOKMARK: "bookmark",
    TABLE_OF_CONTENTS: "table_of_contents",
};

/**
 * Human-readable labels for each resource type
 */
export const RESOURCE_TYPE_LABELS = {
    [RESOURCE_TYPES.FLASHCARD_DECK]: "Flashcard",
    [RESOURCE_TYPES.QUIZ]: "Quiz",
    [RESOURCE_TYPES.ARTICLE]: "Article",
    [RESOURCE_TYPES.BOOKMARK]: "Signet",
    [RESOURCE_TYPES.TABLE_OF_CONTENTS]: "Table des matières",
};

/**
 * Get the label for a resource type
 * @param {string} resourceType - The resource type
 * @returns {string} The human-readable label
 */
export function getResourceTypeLabel(resourceType) {
    return RESOURCE_TYPE_LABELS[resourceType] || resourceType;
}

/**
 * Check if a value is a valid resource type
 * @param {string} value - The value to check
 * @returns {boolean} True if the value is a valid resource type
 */
export function isValidResourceType(value) {
    return Object.values(RESOURCE_TYPES).includes(value);
}
